export enum CertificationRequestStatus {
    REQUESTED = 'Beantragt',
    ACCEPTED = 'Angenommen',
    WAITING = 'Wartend',
    IN_PROGRESS = 'In Bearbeitung',
    PASSED = 'Bestanden',
    NOT_PASSED = 'Nicht bestanden',
    CLOSED = 'Abgeschlossen',
    REJECTED = 'Abgelehnt'
}
